/**
 * Ryan O'Dowd
 * 2024-11-11
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import ContributionGraph from '@containers/Profile/ContributionGraph';
import React from 'react';
import Text from '@components/common/Text';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const StreakRepairDisplay = (props: StreakRepairDisplayProps) => {
  const i18n = hooks.useI18n();
  const styles = hooks.useStyles(getStyles);

  const user = hooks.useTypedSelector((state) => state.oakUser);

  return (
    <View style={[styles.container, props.hasBackground && styles.containerBackground]}>
      {props.hideTitle ? null : <Text style={styles.streakGraphTitle}>{i18n('streakRepair')}</Text>}
      <ContributionGraph
        user={user}
        daysToDisplay={11}// @TODO: should be 10 if today isn't included...depends if a lessons was completed today?
        isHorizontal={true}
        padRestOfWeek={false}
        selectedDate={props.repairStreakDate}
        practiceIsMounted={props.practiceIsMounted}
      />
    </View>
  );
};

class StreakRepairDisplayProps {
  hideTitle?: boolean;
  repairStreakDate?: string;
  hasBackground?: boolean;
  practiceIsMounted?: boolean;
};

export default StreakRepairDisplay;
